import { render, staticRenderFns } from "./SearchTemplate.vue?vue&type=template&id=35ce4bb8&scoped=true&"
import script from "./SearchTemplate.vue?vue&type=script&lang=js&"
export * from "./SearchTemplate.vue?vue&type=script&lang=js&"
import style0 from "./SearchTemplate.vue?vue&type=style&index=0&id=35ce4bb8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35ce4bb8",
  null
  
)

export default component.exports